import type { MenuPage } from '@/content/printMenu/types'
import { BackCoverPage } from '@/components/printMenu/BackCoverPage'
import { BlankMenuPage } from '@/components/printMenu/BlankMenuPage'
import { CoverPage } from '@/components/printMenu/CoverPage'
import { GelServicePage } from '@/components/printMenu/GelServicePage'
import { SectionDividerPage } from '@/components/printMenu/SectionDividerPage'
import { StandardServicePage } from '@/components/printMenu/StandardServicePage'
import { AdditionalServicesPage } from '@/components/printMenu/AdditionalServicesPage'

export function renderMenuPage(page: MenuPage, pageNumber: number, totalPages: number) {
  switch (page.kind) {
    case 'cover':
      return <CoverPage pageNumber={pageNumber} totalPages={totalPages} />
    case 'section':
      return (
        <SectionDividerPage
          title={page.title}
          subtitle={page.subtitle}
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      )
    case 'gel-service':
      return (
        <GelServicePage
          sectionEyebrow={page.sectionEyebrow}
          service={page.service}
          imageSrc={page.imageSrc}
          imageAlt={page.imageAlt}
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      )
    case 'service':
      return (
        <StandardServicePage
          sectionEyebrow={page.sectionEyebrow}
          service={page.service}
          imageSrc={page.imageSrc}
          imageAlt={page.imageAlt}
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      )
    case 'additional-services':
      return (
        <AdditionalServicesPage
          addOnServices={page.addOnServices}
          pageNumber={pageNumber}
          totalPages={totalPages}
        />
      )
    case 'back':
      return <BackCoverPage pageNumber={pageNumber} totalPages={totalPages} />
    case 'blank':
      return <BlankMenuPage />
    default: {
      const _exhaustive: never = page
      return _exhaustive
    }
  }
}
